import { isForeignCode } from '../scanWedge';

// One filter in front of every code source on the Scan page — the camera, a Bluetooth or USB scanner, the typed
// box — mirroring the server's inbound.looks_like_barcode: a product barcode (8–14 digits) or an article number
// (letters, digits and ' ._+/-' with at least one digit, 3–40 characters); never a QR code's URL, never a 16+ hex
// EPC from an RFID hang tag. The camera reads everything in view, so this is what keeps a shelf label's QR or a
// price tag's URL from becoming a lookup. -- Claude, 2026-10-31
export function acceptCode(raw: string | null | undefined): string | null {
  const c = (raw || '').trim();
  if (!c || c.length > 40) return null;
  if (isForeignCode(c)) return null;
  if (/^\d{8,14}$/.test(c)) return c;
  if (/^[0-9A-Fa-f]{16,}$/.test(c)) return null;
  if (/^[A-Za-z0-9 ._+/-]{3,40}$/.test(c) && /\d/.test(c)) return c;
  return null;
}
